var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 35.2119C69.9988 28.4826 68.0811 21.8946 64.474 16.2277C60.8669 10.5609 55.7215 6.05252 49.6468 3.23635C43.5721 0.42018 36.8226 -0.585862 30.1973 0.337326C23.572 1.26051 17.3483 4.07427 12.263 8.44549C7.17775 12.8167 3.44387 18.5624 1.5034 25.0022C-0.437067 31.4421 -0.502866 38.3065 1.31379 44.7828C3.13045 51.2591 6.7535 57.0761 11.754 61.5452C16.7545 66.0143 22.9231 68.9483 29.5295 69.9999V45.3916H20.6378V35.2119H29.5295V27.4534C29.5295 18.6287 34.7482 13.7539 42.7487 13.7539C45.3712 13.7907 47.9875 14.0202 50.5767 14.4405V23.0956H46.1609C45.409 22.9953 44.6444 23.0665 43.9235 23.3038C43.2026 23.5411 42.5441 23.9385 41.9965 24.4665C41.4489 24.9945 41.0264 25.6397 40.7602 26.3542C40.494 27.0687 40.3909 27.8343 40.4585 28.5944V35.2119H50.1652L48.6137 45.3916H40.4686V69.9999C48.7011 68.687 56.198 64.4623 61.6113 58.0854C67.0246 51.7086 69.9992 43.5979 70.0001 35.2119V35.2119Z",
    fill: "#4396B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3a976f0c.svg";
export { ForwardRef as ReactComponent };